export default __webpack_public_path__ + "static/david-haintz-global-adviser-alpha-761c5d4ab0af5b7201e0fd76b84522d7.png";